/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capability_Buyside_TitleInputs */

const en_landing_capability_buyside_title = /** @type {(inputs: Landing_Capability_Buyside_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Buy-Side direct access`)
};

/**
* | output |
* | --- |
* | "Enable Buy-Side direct access" |
*
* @param {Landing_Capability_Buyside_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capability_buyside_title = /** @type {((inputs?: Landing_Capability_Buyside_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capability_Buyside_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capability_buyside_title(inputs)
});